import { render } from "./RemoteHands.vue?vue&type=template&id=19eee9a3"
import script from "./RemoteHands.vue?vue&type=script&lang=js"
export * from "./RemoteHands.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__